export const TableHelpers = {
    data() {
        return {
            // Certificación - Productos
            OCPR: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Producto, Proceso o Servicio',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría de producto, Proceso o Servicio',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo',
                    type: 'custom-html',
                    key: 'level_6_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Modificatorias a los Documentos Normativos',
                    type: 'text',
                    key: 'level7',
                },
                {
                    title: 'Tipo de esquema de certificación',
                    type: 'custom-html',
                    key: 'level_8_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Especificación técnica',
                    type: 'text',
                    key: 'level9',
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Certificación - Sistemas de Gestión Antisoborno
            CSGAS: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Certificación - Sistemas de Gestión de Calidad y Certificación de Sistemas de Gestión Ambiental
            OCSG: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Sector IAF',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Certificación - Sistemas de Gestión de la Inocuidad Alimentaria
            CSIA: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Grupo',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Subcategoría',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo específico para FSSC',
                    type: 'custom-html',
                    key: 'level_8b',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Certificación - Personas
            OCPE: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Personal certificado',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría de personal',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Documento normativo',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Esquema de certificaciòn de personas',
                    type: 'text',
                    key: 'level7',
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Certificación - Sistemas de Gestión de la Calidad para Dispositivos Médicos
            CSDM: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Sector/Referencia',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Actividad',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Inspección
            OINSP: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo de inspección/alcance',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Elemento a inspeccionar',
                    type: 'custom-html',
                    key: 'level_4_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Tipo de inspección o metodología',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Tipo de Organismo en base a la independencia (A,B,C)',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Procedimientos de Inspección',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: 'Código tipo de la norma o especificación técnica/Vigencia de la norma o especificación técnica (Año de publicación, reafirmación, edición/revisión (cuando aplique))',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (value) => {
                        return value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Laboratorio - Ensayos / Investigación y Control de Calidad
            OENY: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Organización',
                    type: 'custom-html',
                    key: 'org',
                    modifier: (item) => {
                        let location;
                        if (item) {
                            if (item.canton) {
                                location = "Unidad Técnica - "+ item.canton.name;
                            } else {
                                "Unidad Técnica - "+ item.city;
                            }
                        } else {
                            location = 'Matriz';
                        }
                        return location;
                    }
                },
                // {
                //     title: 'Sector',
                //     type: 'custom-html',
                //     key: 'level_2',
                //     modifier: (item) => {
                //         return item.value;
                //     }
                // },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Producto',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Técnica',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Ensayo',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Rango',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Método Interno',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Método Referencia',
                    type: 'custom-html',
                    key: 'level10',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Laboratorio - Clínico
            OCLN: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Ubicación',
                    type: 'custom-html',
                    key: 'org',
                    modifier: (item) => {
                        return item ? item.value : 'Matriz';
                    }
                },
                // {
                //     title: 'Sector',
                //     type: 'custom-html',
                //     key: 'level_2',
                //     modifier: (item) => {
                //         return item.value;
                //     }
                // },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Campo de Análisis',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Muestra',
                    type: 'custom-html',
                    key: 'level_7_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Análisis',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        if(item){
                            return item.value;
                        }
                    }
                },
                {
                    title: "Técnica",
                    type: "custom-html",
                    key: "level_5",
                    modifier: (item) => {
                      return item.value;
                    },
                },
                {
                    title: "Método de Análisis",
                    type: "custom-html",
                    key: "level9",
                    modifier: (item) => {
                      return item;
                    },
                },
                // {
                //     title: 'Ensayo',
                //     type: 'custom-html',
                //     key: 'level_6',
                //     modifier: (item) => {
                //         return item.value;
                //     }
                // },
                {
                    title: "Procedimiento",
                    type: "custom-html",
                    key: "level10",
                    modifier: (item) => {
                      return item;
                    },
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
                // {
                //     title: 'Método Referencia',
                //     type: 'text',
                //     key: 'level10',
                // },
            ],
            // Laboratorio - Calibración
            OEYC: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Ubicación',
                    type: 'custom-html',
                    key: 'org',
                    modifier: (item) => {
                        let location;
                        if (item) {
                            if (item.canton) {
                                location = "Unidad Técnica - "+ item.canton.name;
                            } else {
                                location = "Unidad Técnica - "+ item.city;
                            }
                        } else {
                            location = 'Matriz';
                        }
                        return location;
                    }
                },
                // {
                //     title: 'Sector',
                //     type: 'custom-html',
                //     key: 'level_2',
                //     modifier: (item) => {
                //         return item.value;
                //     }
                // },
                {
                    title: "Categoría",
                    type: "custom-html",
                    key: "level_3",
                    modifier: (item) => {
                      return item ? item.value : null;
                    },
                },
                {
                    title: "Campo de calibración",
                    type: "custom-html",
                    key: "level_4",
                    modifier: (item) => {
                      return item ? item.value : null;
                    },
                },
                {
                    title: "Magnitud y Submagnitud",
                    type: "custom-html",
                    key: "level_5",
                    modifier: (item) => {
                      return item ? item.value : null;
                    }
                },
                {
                    title: "Rango de Medida",
                    type: "custom-html",
                    key: "level7",
                    modifier: (item) => {
                      return item;
                    }
                },
                {
                    title: "Incertidumbre",
                    type: "custom-html",
                    key: "level8",
                    modifier: (item) => {
                      return item;
                    }
                },
                {
                    title: "Instrumentos",
                    type: "custom-html",
                    key: "level_6_selected",
                    modifier: (item) => {
                      let tmp = ''
                      item.forEach((element, index) => {
                          tmp += `<p>${element.scope_master.description}</p>`
                      });
                      return tmp;
                    }
                },
                {
                    title: "Método Interno",
                    type: "custom-html",
                    key: "level9",
                    modifier: (item) => {
                      return item;
                    },
                },
                {
                    title: "Método Referencia (revisión/edición)",
                    type: "custom-html",
                    key: "level10",
                    modifier: (item) => {
                      return item;
                    },
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // Laboratorio - Proveedores de Ensayos de Aptitud
            OEAP: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Programa',
                    type: 'custom-html',
                    key: 'level7',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Ensayo / Magnitud',
                    type: 'custom-html',
                    key: 'level8',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Ítem de Ensayo de Aptitud',
                    type: 'custom-html',
                    key: 'level9',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Frecuencia',
                    type: 'custom-html',
                    key: 'level10',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Método para el Valor',
                    type: 'custom-html',
                    key: 'level11',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            //verificacion - verificacion
            OVV: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Actividad',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Categoría',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Programa',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Documento Normativo',
                    type: 'custom-html',
                    key: 'level_5_selected',
                    modifier: (item) => {
                        let tmp = ''
                        item.forEach((element, index) => {
                            tmp += `<p>${element.scope_master.description}</p>`
                        });
                        return tmp;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_6',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // SISTEMAS DE GESTIÓN DE LA SEGURIDAD Y SALUD EN EL TRABAJO (CSST
            CSST: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Sector IAF',
                    type: 'custom-html',
                    key: 'level_5',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            // SISTEMAS DE GESTIÓN DE LA ENERGÍA (CSEN).
            CSEN: [
                {
                    title: '#',
                    type: 'custom-html',
                    key: 'rownum',
                    modifier: (item) => {
                        return item;
                    }
                },
                {
                    title: 'Sector',
                    type: 'custom-html',
                    key: 'level_2',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de acreditación',
                    type: 'custom-html',
                    key: 'level_3',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Norma de certificación',
                    type: 'custom-html',
                    key: 'level_4',
                    modifier: (item) => {
                        return item.value;
                    }
                },
                {
                    title: 'Condición',
                    type: 'custom-html',
                    key: 'condicion_scopes',
                    modifier: (item, row) => {
                        
                        if(row.condicion_scope) {
                            
                            return `<span class="badge badge-sm badge-pill badge-primary">${item.name}</span>`;
                        } else {
                            if ( row.accreditation_application.accreditation_type_id == 1) {
                                return `<span class="badge badge-sm badge-pill badge-primary">Otorgar</span>`;
                            }
                            if ( row.accreditation_application.accreditation_type_id == 2 || row.accreditation_application.accreditation_type_id == 10 || row.accreditation_application.accreditation_type_id == 11) {
                                return `<span class="badge badge-sm badge-pill badge-success">Ampliar</span>`;
                            }
                        }
                        
                    }
                },
            ],
            actionObj: {
                title: '',
                type: 'action',
            }
        }
    },
}
